<div>
  <h3 *ngIf="showHeader()"
      [class]="classes[(level - 1)]"
  >{{ processStringForTranslations(sectionTitle) + (level === 1 ? ':' : '') }}</h3>
  <div *ngIf="dataCopy && dataCopy['inputs'] && dataCopy['inputs'].length > 0"
       class="inputs"
  >
    <mat-table [dataSource]="dataCopy['inputs']">

      <ng-container [matColumnDef]="nameHeader">
        <mat-header-cell *matHeaderCellDef>{{ nameHeader }}</mat-header-cell>
        <mat-cell *matCellDef="let input">
          <ng-container *ngIf="input">
            <div [innerHTML]="processStringForTranslations(input[nameHeader])"></div>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container [matColumnDef]="valueHeader">
        <mat-header-cell *matHeaderCellDef>{{ valueHeader}}</mat-header-cell>
        <mat-cell *matCellDef="let input">
          <div [innerHTML]="processStringForTranslations(input[valueHeader])"></div>
        </mat-cell>
      </ng-container>

      <ng-container [matColumnDef]="unitHeader">
        <mat-header-cell *matHeaderCellDef>{{unitHeader}}</mat-header-cell>
        <mat-cell *matCellDef="let input">
          <div [innerHTML]="processStringForTranslations(input[unitHeader])"></div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
  </div>
  <div *ngIf="dataCopy">
    <div *ngFor="let key of Object.keys(dataCopy['subSection'])">
      <app-input-summary-subtable
        [subtable]="dataCopy['subSection'][key]"
        [level]="level + 1"
        [sectionTitle]="key"
      >
      </app-input-summary-subtable>
    </div>
  </div>
</div>
